/**
 * «توی شرح اینا رو بنویس» — فهرستی که پشتِ «؟»ِ کادرِ شرحِ سیگنال باز می‌شه،
 * به همون ترتیبی که کسی که دعوت شده سوال می‌پرسه: اول «این چیه»، بعد
 * چیزهای عملی.
 *
 * قرینه‌ی `DESCRIBE_KEYS` در lib/myEvents.ts، برای سیگنال به‌جای رخداد. این‌جاست
 * نه توی خودِ فرم، چون چهار تا فرم لازمش دارن (ساخت و ویرایش، در دو اپ) و یه
 * فهرستِ کپی‌شده بعد از اولین تغییر می‌شه چهار تا فهرستِ کمی متفاوت.
 * مقدارها کلیدِ i18nـن.
 *
 * هزینه عمداً یکی از همین سطرهاست و فیلدِ جدا نیست: تا دیروز دو تا جای
 * جداگانه برای «اطلاعاتِ بیشتر» بود (شرح و جزئیات) و کاربر نمی‌دونست کدوم
 * مالِ چیه.
 */
export const SIGNAL_NOTE_KEYS = [
  'signalNoteWhat',
  'signalNoteHow',
  'signalNoteBring',
  'signalNoteCost',
] as const;
